<template>
  <div class="app-container">
    <el-table
      ref="elTable"
      :data="tableData"
      :border="true"
      size="small"
      :height="tableHeight"
      @header-dragend="headerWidthChange"
    >
      <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in currentColumns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :align="item.fixed"
        :width="item.width"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, ind) in getCurrentColumns"
        :key="ind + 100"
        :prop="item.prop"
        :label="item.label"
        :align="item.fixed"
        :width="item.width"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页工具：游标分页，上一页/下一页的禁用态由 hasPrevious / hasMore 决定 -->
    <div class="pagination">
      <cursor-pagination
        :total="total"
        :page-size="queryForm.pageSize"
        :page-sizes="pageSizeOptions"
        :has-more="hasMore"
        :has-previous="hasPrevious"
        @prev-click="handlePrevPage"
        @next-click="handleNextPage"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { apiSiteExpenseGetPage } from '@/api/finance/receivables';
import { cloneDeep } from 'lodash-es';
import CursorPagination from '@/components/CursorPagination';
import { EXAMINE_TABLE_QUERY } from './../utils';

export default {
  name: 'BatchNumberDetail',

  components: {
    CursorPagination
  },

  props: {
    // 搜索条件
    detailQuery: {
      type: Object,
      required: true
    },
    // batchNumber: {
    //   type: String,
    //   default: ''
    // },
    billBatchData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 20,
        cursor: null, // 游标标记：点击上一页/下一页时分别赋 previousCursor / nextCursor
        params: {
          ...EXAMINE_TABLE_QUERY,
          receiptNumber: '' // 收款单号
        }
      },
      pageSizeOptions: [20, 50, 100],
      total: 0,
      hasMore: false, // 是否有下一页
      hasPrevious: false, // 是否有上一页
      nextCursor: null, // 接口返回的下一页游标
      previousCursor: null, // 接口返回的上一页游标
      tableData: [],
      currentColumns: [],
      getCurrentColumns: [],
      selectData: [],
      tableHeight: 0,
      totalFee: 0
    };
  },
  computed: {
    columnList() {
      return [
        {
          label: this.$i18n.t('basicData.all'), // '全部',
          prop: '',
          children: [
            // 业务单号
            { prop: 'waybillNumber', label: this.$i18n.t('receivablePayable.TicketNumber'), width: 180, fixed: 'left', highlight: false, disabled: true },
            // 客户单号
            { prop: 'customerNumber', label: this.$i18n.t('receivablePayable.CustomerTrackingNumber'), width: 180, fixed: 'left', highlight: false, disabled: true },
            // 网点
            { prop: 'siteName', label: this.$i18n.t('basicData.Outlets'), width: 160, fixed: 'left', highlight: false, disabled: true },
            // 客户
            { prop: 'customerAlias', label: this.$i18n.t('receivablePayable.customer'), width: 160, fixed: 'left', highlight: false, disabled: true },
            // 揽收入库时间
            { prop: 'inputTime', label: this.$i18n.t('receivablePayable.TimeToCollectIntoTheTreasury'), width: 140, fixed: 'left', highlight: false, disabled: true },
            // 揽收重量
            { prop: 'collectWeight', label: this.$i18n.t('receivablePayable.CollectedWeight'), width: 110, fixed: 'left', highlight: true, disabled: true },
            // 计费重量
            { prop: 'chargeWeight', label: this.$i18n.t('receivablePayable.BillableWeight'), width: 110, fixed: 'left', highlight: true, disabled: true },
            // 应收费用
            { prop: 'totalFee', label: this.$i18n.t('basicData.FeesApply'), width: 110, fixed: 'left', highlight: false, disabled: false }
          ]
        }
      ];
    }
  },
  watch: {
    // 查询条件变更：游标失效，重置为首页查询
    detailQuery: {
      deep: true,
      handler(query) {
        if (this.isSameDetailQuery(query)) return;
        this.applyDetailQuery();
        this.resetCursorPagination();
        this.getExamineTableData();
      }
    }
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.tableHeight = document.body.clientHeight - 180;
    this.currentColumns = this.columnList[0].children;
    this.tableKey = new Date().getTime();

    this.applyDetailQuery();
    this.getExamineTableData();
  },
  mounted() {
    // 页面加载的时候设置table的高度
    this.tableHeight = document.body.clientHeight - 180;
    // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
    window.onresize = () => {
      this.tableHeight = document.body.clientHeight - 180;
    };
  },

  methods: {
    // 表头宽度变化
    headerWidthChange() {
      this.$nextTick(() => {
        this.$refs.elTable.doLayout();
      });
    },

    // 查询条件赋值到请求参数
    applyDetailQuery() {
      const { receiptNumber, siteId, name } = this.detailQuery;
      this.queryForm.params.receiptNumber = receiptNumber;
      this.queryForm.params.siteId = siteId;
      this.queryForm.params.name = name;
    },

    // 查询条件是否未发生变化（避免同一批赋值触发重复请求）
    isSameDetailQuery(query = {}) {
      const { receiptNumber, siteId, name } = this.queryForm.params;
      return query.receiptNumber === receiptNumber && query.siteId === siteId && query.name === name;
    },

    // 重置游标分页到第一页
    resetCursorPagination() {
      this.queryForm.pageNumber = 1;
      this.queryForm.cursor = null;
      this.nextCursor = null;
      this.previousCursor = null;
      this.hasMore = false;
      this.hasPrevious = false;
    },

    // 下一页：把接口返回的 nextCursor 赋值给 cursor
    handleNextPage() {
      this.queryForm.pageNumber += 1;
      this.queryForm.cursor = this.nextCursor;
      this.getExamineTableData();
    },

    // 上一页：把接口返回的 previousCursor 赋值给 cursor
    handlePrevPage() {
      this.queryForm.pageNumber = Math.max(1, this.queryForm.pageNumber - 1);
      this.queryForm.cursor = this.previousCursor;
      this.getExamineTableData();
    },

    // 每页条数变化：游标失效，回到第一页重新查询
    handleSizeChange(size) {
      this.queryForm.pageSize = size;
      this.resetCursorPagination();
      this.getExamineTableData();
    },

    // 获取列表
    getExamineTableData() {
      const param = cloneDeep(this.queryForm);
      this.getCurrentColumns = [];
      // 获取列表数据
      apiSiteExpenseGetPage(param).then(resp => {
        if (resp.code === 200) {
          this.tableData = resp.data || [];
          this.total = resp.total || 0;
          this.hasPrevious = !!resp.hasPrevious;
          // 无数据时不允许继续向后翻页
          this.hasMore = !!resp.hasMore && this.tableData.length > 0;
          this.nextCursor = resp.nextCursor || null;
          this.previousCursor = resp.previousCursor || null;
          if (this.tableData.length > 0) {
            this.getCurrentColumns = [];
            resp.columns.map(item => {
              const obj = {
                prop: item.prop,
                label: item.label.split('_')[0],
                width: 200,
                fixed: 'left',
                highlight: false
              };
              this.getCurrentColumns.push(obj);
              this.$nextTick(() => {
                this.$refs.elTable.doLayout();
                this.rowSelectFlag = true;
                this.tableData.map(list => {
                  const matchedIndex = this.selectData.findIndex(itemList => itemList.id === list.id);
                  this.$refs.elTable.toggleRowSelection(list, matchedIndex !== -1);
                });
                this.rowSelectFlag = false;
              });
            });
          }
        }
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.app-container {
  padding: 10px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}

.pagination__total {
  margin-right: 12px;
  font-size: 13px;
  font-weight: normal;
  color: #606266;
}
</style>
